import React from "react";
import {useQuery} from "../../actions/actionCreators";

/**
 * A component to detect Marketing token and save it.
 * @returns {null}
 * @constructor
 */
const Marketing = () => {
    const query = useQuery();
    const taToken = query.get('tatoken');
    const utmSource = query.get('utm_source');
    /**
     * Set new local storage item for takhfifan if it exists.
     * To use it in {sendOrder}.
     */
    if (taToken && utmSource === 'takhfifan'){
        localStorage.setItem('marketer', 'takhfifan');
        localStorage.setItem('maToken', taToken);
    }

    return null;
}
export default Marketing;
